import React from 'react';

import { LineageEntityTypeContext } from '@neptune/shared/entity-domain';

export const useLineageEntityTypeContext = (): LineageEntityTypeContext => {
  return React.useContext(LineageEntityTypeContext);
};
